module.exports = __webpack_public_path__ + "images/emoji/congratulations.4e433c5fa540d97d0e8f.png";